import React from "react";
import "./styles.scss";
export const Text = ({ text, textAdditional, customClassText }) => {
  return (
    <div className={`${textAdditional ? "container-text-additional" : ""}`}>
      <p className={`text ${customClassText}`}>{text}</p>
      {textAdditional && (
        <>
          <hr className="separator" />
          <p className="text-additional">{textAdditional}</p>
        </>
      )}
    </div>
  );
};
